import React from 'react';
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
// import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import Image from "../../../images/image.png"
import { Link } from "react-router-dom";
import { useRedirect } from "react-admin";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#F7F7F7",
    }
  },
  Avatar: {
    height: "35px"
  }
}));
export default function MentorProfile(handleSubmit,
  reset,
  submitting,
  pristine,
  values,  
  props,
  ...rest) {
  const classes = useStyles();
  const redirect = useRedirect()

  const handleClick = () => {
    return (
      redirect('/mentorprofile')
    )
  }
  var card = [
    {
      name: "Anna Sthesia",
      certificate: "Certified information systems auditor (CISA)",
      // image:"C:\Users\lenovo\Desktop\demo1\app\src\images"
    },
    {
      name: " Sthesia Anna ",
      certificate: "Certified information systems auditor (CISA)",
      // image:"C:\Users\lenovo\Desktop\demo1\app\src\images"
    },
    {
      name: "Anna Sthesia",
      certificate: "Certified information systems auditor (CISA)",
      // image:"C:\Users\lenovo\Desktop\demo1\app\src\images"
    },]
  return (
    <div className={classes.div}>
      <div style={{ paddingTop: "20px", paddingLeft: "4%", paddingRight: "4%" }}>
        {/* <Typography >Home/Mentor Profile</Typography> */}
<from onSubmit={handleSubmit} noValidate>

        <Typography varinat="h6" style={{ marginTop: "40px", fontWeight: "540" }}>Similar Mentors</Typography>
        <Grid container spacing="3">
          {card.map(card => (
            <Grid item sm={4} xs={12}>
              <Card style={{ marginTop: "0px", boxShadow: "none", paddingBottom: "20px" }}>
                <CardHeader
                  avatar={
                    <Link onClick={handleClick}>
                      <Avatar alt="Cindy Baker" src={Image} style={{ height: "50px", width: "50px" }} />
                    </Link>
                  }
                  title={card.name}
                  subheader={card.certificate}
                />
              </Card>

            </Grid>
          ))}

        </Grid>
        </from>
      </div>
    </div>
  );
}
